<template>
  <section
    id="productInfo"
  >
    <div class="row">
      <label class="label">
        Ürün Adı
        <span class="required">*</span>
      </label>
      <div>
        <input
          type="text"
          class="form-control"
          :class="{'is-invalid' : errors.has('productName')}"
          v-model="product.title"
          name="productName"
          v-validate="{required: true, max: 100 }"
          data-vv-as="Ürün Adı"
          placeholder="Örnek: Arçelik TKM 9961 B Telve Türk Kahve Makinesi 0-0-TKM9961B"
          autocomplete="off"
          v-readonly
        >
        <div class="invalid-feedback">
          {{ errors.first('productName') }}
        </div>
      </div>
    </div>
    <ProductImage
      :images="product.images"
      @selectedImages="selectedImages"
      @updateOrder="updateOrder"
    />
    <div class="row">
      <label class="label">
        Model Kodu
        <span class="required">*</span>
      </label>
      <div>
        <input
          type="text"
          class="form-control"
          :class="{'is-invalid' : errors.has('productMainId')}"
          v-model="product.productMainId"
          name="productMainId"
          v-validate="{required: true, max:40 }"
          data-vv-as="Model Kodu"
          autocomplete="off"
          v-readonly
          :disabled="product.approved"
        >
        <div class="invalid-feedback">
          {{ errors.first('productMainId') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="label">
        Barkod
        <span class="required">*</span>
      </label>
      <div>
        <input
          type="text"
          class="form-control"
          :class="{'is-invalid' : errors.has('barcode')}"
          v-model="product.barcode"
          name="barcode"
          v-validate="{required: true, validBarcode: '^[A-Za-zÇçŞşİĞğÜüÖöı0-9_.-]*$', max: 40}"
          data-vv-as="Barkod"
          autocomplete="off"
          v-readonly
          :disabled="product.approved"
        >
        <div
          class="invalid-feedback"
          v-html="errors.first('barcode')"
        />
      </div>
    </div>
    <div class="row">
      <label class="label">
        Kategori
      </label>
      <CategoryTree
        v-model="product.category"
        name="productCategory"
        :options="getCategoriesList"
        placeholder="Kategori Seçimi"
        @onSelect="onSelect"
        :disabled="product.approved"
        v-validate="{requiredSelect: true }"
        :class="{'is-invalid' : errors.has('productCategory')}"
        data-vv-as="Kategori"
      />
      <div
        class="invalid-feedback"
        v-html="errors.first('productCategory')"
      />
    </div>
    <div class="row">
      <label class="label">
        Durum
      </label>
      <StatusLabel
        :product="product"
      />
    </div>
    <div class="row">
      <label class="label">
        Stok Kodu
      </label>
      <input
        type="text"
        class="form-control"
        v-model="product.stockCode"
        name="stockCode"
        data-vv-as="Stok Kodu"
        autocomplete="off"
        v-readonly
      >
    </div>
    <div class="row">
      <label class="label">
        Marka
      </label>
      <BrandSelect
        name="brand"
        v-model="product.brand"
        :disabled="product.approved"
        v-validate="{requiredSelect: true }"
        :class="{'is-invalid' : errors.has('brand')}"
        data-vv-as="Marka"
      />
      <div
        class="invalid-feedback"
        v-html="errors.first('brand')"
      />
    </div>
    <div class="row">
      <label class="label">
        Açıklama
      </label>
      <div
        class="form-control contenteditable"
        ref="contentEditableDescription"
        contenteditable="true"
        @input="changeDescription"
      />
    </div>
  </section>
</template>
<script>
import categoryService from '@/services/category';

import ProductImage from './Components/ProductImage';
import CategoryTree from '@/components/CategoryTree/Index';
import StatusLabel from './Components/Status';
import BrandSelect from '@/components/BrandSelect/Index';

export default {
  name: 'ProductInfo',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    BrandSelect, StatusLabel, CategoryTree, ProductImage,
  },
  data () {
    return {
      categories: [],
    };
  },
  computed: {
    getCategoriesList () {
      return this.categories;
    },
  },
  methods: {
    async getCategories () {
      const response = await categoryService.getCategories({
        showIsClosed: true,
      });
      this.categories = response.Categories;
    },
    changeDescription (e) {
      this.product.description = e.target.innerHTML;
    },
    onSelect (category) {
      this.product.pimCategoryId = category.Id;
    },
    selectedImages (images) {
      this.product.images = [
        ...images,
        ...this.product.images,
      ];
    },
    updateOrder (images) {
      this.product.images = images;
    },
    async validate () {
      const isValid = await this.$validator.validateAll();
      return isValid;
    },
  },
  async created () {
    await this.getCategories();
    this.$refs.contentEditableDescription.innerHTML = this.product.description;
  },
};
</script>
